import getWebComponentGameHandles from "@casino/shared/utils/getWebComponentGameHandles";

export default function isWebComponentGame(handle?: string): boolean {
  return getWebComponentGameHandles().includes(handle ?? "");
}
